import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { TBreadcrumb } from 'types/breadcrumb.type';

export type TUIState = {
  breadcrumbs: TBreadcrumb[];
};

export const initialState: TUIState = {
  breadcrumbs: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setBreadcrumbs: (state, { payload }: PayloadAction<TBreadcrumb[]>) => {
      state.breadcrumbs = payload;
    },
  },
});

export default uiSlice.reducer;
export const { setBreadcrumbs } = uiSlice.actions;
